import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

const TESTGROUP_ENDPOINT = {
  GROUPS: "/test-groups",
}

export type TestCreateData = {
  name: string
  classIds: string[]
  capacity: number
  testDateTime: string
  status: "active" | "inactive"
  branch: string
  groupIdentifier: string
  system?: string
  session?: string
  isForAllClasses?: boolean
}

export type UpdateTestGroup =  TestCreateData & {
  _id: string
}


export type TestGroupClass = { _id: string; name: string }

export type TestGroupResponse = Omit<TestCreateData, "classIds" | "session"> & {
  _id: string
  classIds: TestGroupClass[]
  session:{
    _id:string
  }
   isDeleted?: boolean
   // Already returned by GET /test-groups (no .select() restriction on the
   // backend) — just wasn't typed or shown here before.
   currentStudents?: number
}

export type PaginationData = {
  page: number
  hasNextPage?: boolean
  hasPrevPage?: boolean
  limit: number
  total: number
  totalPages: number
}

export type ApiResponse = {
  data: TestGroupResponse[]
  pagination: PaginationData
  status: string
}

const getAllGroups = async ({
  page = 1,
  limit = 10,
  sortBy,
  sortOrder,
  searchText: search,
  class: appliedClass,
  status,
  startDate,
  endDate,
  system,
  session,
}: {
  page?: number
  limit?: number
  sortBy?: string
  sortOrder?: string
  searchText?: string
  class?: string
  status?: string
  startDate?: string
  endDate?: string
  system?: string
  session?: string
} = {}): Promise<ApiResponse> => {
  const response = await apiClient({
    url: appendQueryParams(TESTGROUP_ENDPOINT.GROUPS, {
      page,
      limit,
      sortBy,
      sortOrder,
      searchText: search,
      classId: appliedClass,
      status,
      startDate,
      endDate,
      system,
      session,
    }),
    method: "GET",
  })
  return response.data
}

const createTestGroup = async (data: any): Promise<TestCreateData[]> => {
  const response = await apiClient({
    url: TESTGROUP_ENDPOINT.GROUPS,
    method: "POST",
    data,
  })
  return response.data
}

const updateTestGroup = async (
  data: UpdateTestGroup
): Promise<UpdateTestGroup> => {
  const response = await apiClient({
    url: `${TESTGROUP_ENDPOINT.GROUPS}/${data._id}`,
    method: "PUT",
    data,
  })
  return response.data
}

const deleteGroups = async (_id: string) => {
  const response = await apiClient({
    url: `${TESTGROUP_ENDPOINT.GROUPS}/${_id}`,
    method: "DELETE",
  })

  return response.data
}

export { createTestGroup, deleteGroups, updateTestGroup, getAllGroups }
